import './App.css';
import './assets/locale/i18n';

import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import useModelCatalog from './hooks/useModelCatalog';
import Container from './layout/Container/Container';
import Error from './layout/Error/Error';
import CvcPage from './pages/cvc/CvcPage';
import IndexPage from './pages/index/IndexPage';
import MessagePage from './pages/message/MessagePage';
import MssPage from './pages/mss/MssPage';
import JobEventsBridge from './providers/JobEventsBridge';
import { WebSocketContextProvider } from './providers/WebSocketProvider';
import { BasicFontSize } from './styles/Typography';

/**
 * fixme darcy 빌드 에러를 방지하기 위한 수정이 되어 있습니다. 무시하고 덮어 쓰셔요~
 */
function App() {
  // Load the runtime model catalog (public/models.json) once at boot
  useModelCatalog();

  // Set basic font size
  useEffect(() => {
    document.documentElement.style.fontSize = `${BasicFontSize}px`;
  }, []);

  return (
    <WebSocketContextProvider>
      {/* ISSUE-030: job events + reconciliation survive route changes — the
          subscriber lives above <Routes>, next to the provider that already
          does. */}
      <JobEventsBridge />
      <Routes>
        <Route path="/">
          <Route element={<Container />}>
            {/* ISSUE-004: the boundary sits INSIDE the Container layout route
                so a page that throws during render only replaces the page
                area — Container's header/navigation stays mounted. The
                distinct `key` per route makes React remount the boundary on
                navigation; without it the same instance (same element type in
                the same Outlet slot) would keep its error state and show the
                fallback for the page the user navigated TO. */}
            <Route
              index
              path="cvc"
              element={
                <ErrorBoundary key="cvc">
                  <CvcPage />
                </ErrorBoundary>
              }
            />
            <Route
              path="mss"
              element={
                <ErrorBoundary key="mss">
                  <MssPage />
                </ErrorBoundary>
              }
            />
          </Route>
        </Route>

        {/* ISSUE-042: MessagePage fills its parent rather than the viewport,
            and this route renders OUTSIDE the Container layout — its only
            ancestors are #root and body, neither of which has a height, so a
            percentage would collapse. The app's own page-slot class supplies
            the definite height, giving both MessagePage consumers the same
            parent contract without touching global CSS. */}
        <Route
          path="/error"
          element={
            <div className="sup-container">
              <MessagePage message={<Error />} />
            </div>
          }
        ></Route>
        <Route index element={<IndexPage />} />
        <Route path="*" element={<Navigate to="/cvc" replace />} />
      </Routes>
    </WebSocketContextProvider>
  );
}

export default App;
